import { render, staticRenderFns } from "./FirstCallManage.vue?vue&type=template&id=0ada22e5&"
import script from "./FirstCallManage.vue?vue&type=script&lang=js&"
export * from "./FirstCallManage.vue?vue&type=script&lang=js&"
import style0 from "./FirstCallManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports